import React, { useReducer, useEffect, useContext, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Tabs, Tab, Alert } from "react-bootstrap";
import { BreadcrumbContext } from "../../../contexts/BreadcrumbContext";
import axios from "../../../config/axios";
import BlockErrorMessage from "../../UI/errorMessages/BlockErrorMessage";
import DashboardLayout from "../../UI/layouts/DashboardLayout";
import ModuleHeader from "../../UI/modules/views/partials/common/ModuleHeader";
import moduleConfig from "./moduleConfig";
import {
  detailsReducer,
  memberDetailsInitialState,
} from "./reducers/detailsReducer";
import { Card, Col, Row } from "react-bootstrap";
import { OverlayLoading } from "../../UI/loading/OverlayLoading";
//import PollSubmissionQuestionsListing from "./partials/details/PollSubmissionQuestionsListing";
import ModuleDisplayRichText from "../../UI/modules/fieldsDisplay/ModuleDisplayRichText";
import PollData from "./partials/stats/PollData";
import { BarChart } from "../../UI/graphs/BarChart";
import { barChartConfig } from "../../../config/barChartConfig";
import PollQuestion from "./partials/stats/PollQuestion";


const PollStatsView = () => {
  const { setBreadcrumb } = useContext(BreadcrumbContext);
  let { pollId } = useParams();
  const [poll, setPoll] = useState(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const [detailsState, detailsDispatch] = useReducer(
    detailsReducer,
    memberDetailsInitialState
  );

  let breadcrumbs = {
    pollListing: {
      label: "Polls",
      url: `/polls`,
    },
    pollDetails: {
      label: "Poll Details",
      url: `/polls/${pollId}`,
    },
    pollStats: {
      label: 'Stats',
    },
  };

  const back = () => {
    console.log("back")
    if (activeIndex !== 0) {
      setActiveIndex(activeIndex - 1)
    }
  }

  const next = () => {
    //console.log("next clicked")
    if (activeIndex < (poll.questions.length - 1)) {
      setActiveIndex(activeIndex + 1)
    }
  }

  const loadItem = async () => {
    if (pollId) {
      detailsDispatch({
        type: "FETCH_REQUEST",
      });
      try {
        const res = await axios.get(`${moduleConfig.url}/${pollId}`); //
        setPoll(res.data.item)
        detailsDispatch({
          type: "FETCH_SUCCESS",
          payload: res.data,
        });
      } catch (error) {
        detailsDispatch({
          type: "FETCH_FAILURE",
          payload: error,
        });
      }
    }
  };
  useEffect(() => {
    loadItem();
    setBreadcrumb([
      breadcrumbs.pollListing,
      breadcrumbs.pollDetails,
      breadcrumbs.pollStats
    ]);
  }, [pollId]);


  return (
    <DashboardLayout>
      {detailsState.isFetching && <OverlayLoading />}
      {poll && !detailsState.isFetching && (
        <>
          {detailsState.hasError ? (
            <BlockErrorMessage error={detailsState.error} />
          ) : (
            <>
              {detailsState.data.item ? (
                <>
                  <ModuleHeader
                    moduleTitle={`View ${moduleConfig.singleItemTitle}`}
                    moduleUrl={moduleConfig.url}
                  ></ModuleHeader>

                  <PollData poll={poll} />
                  {poll.questions && poll.questions[activeIndex] ? (
                    <Card>
                      <Card.Body className="p-0">
                        <PollQuestion question={poll.questions[activeIndex]} />
                        {/* <br /> */}
                        <div className="buttonContainer text-center mb-3">
                          {activeIndex !== 0 && (
                            <>
                              <span
                                className="btn btn-default ms-2"
                                onClick={() => back()}
                              >
                                Back
                              </span>
                            </>
                          )}
                          {activeIndex !== poll.questions.length - 1 && (
                            <>
                              <span
                                className="btn btn-primary ms-2"
                                onClick={() => next()}
                              >
                                Next
                              </span>
                            </>
                          )}
                        </div>
                      </Card.Body>
                    </Card>
                  ) : <Alert variant="warning">No Stats found.</Alert>}
                </>
              ) : (
                <Alert variant="warning">No records found.</Alert>
              )}
            </>
          )}
        </>
      )
      }
    </DashboardLayout >
  );
};

export default PollStatsView;
